
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="text-2xl font-bold text-orange-500 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              ちょこっとハウス
            </div>
            <p className="text-gray-300 mb-4">
              秋田県湯沢・横手エリアで<br />
              二人暮らしにぴったりの住まいを提供
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">サービス</h3>
            <ul className="space-y-2 text-gray-300">
              <li>住宅設計・建築</li>
              <li>無料相談</li>
              <li>資料請求</li>
              <li>アフターサポート</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">お問い合わせ</h3>
            <div className="text-gray-300 space-y-2">
              <p>湯沢開発株式会社</p>
              <p>秋田県湯沢・横手エリア</p>
              <p>
                <i className="ri-phone-line mr-2"></i>
                お電話でのご相談も承ります
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 ちょこっとハウス - 湯沢開発株式会社. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="text-orange-500 hover:text-orange-400 ml-2">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
